import { ref, reactive, computed, shallowRef } from 'vue'

// list of availeble [data-driver-element] initialized thru directive v-aw-driver-element
const elements = reactive(new Set())

// list of active tours - initialized thru directive v-aw-driver-tour={ name: 'name', active: true, settings: {} }
const toursActive = reactive(new Map())

// show driver? - true, false, 'auto'
const showDriver = ref(false)

// current user role
const currentRole = ref(null)

// list of scenarios
const scenarios = shallowRef([])

// list of viewed scenarios in current session
const viewedAutoplayScenariosIds = reactive(new Set())

// curent available scenarios
// - scenario with currently active tour and correct settings
// - scenario which has valid steps - by role and currently available elements
const availableScenarios = computed(() => {
  const scenariosToReturn = []

  scenarios.value.forEach((scenario) => {
    // filter scenario by active tours
    let tourFound = false
    for (let index = 0; index < scenario.tours.length; index++) {
      const tour = scenario.tours[index];
      
      if (toursActive.has(tour)) {
        tourFound = true

        if (scenario.settings?.js) {
          for (const [key, value] of Object.entries(scenario.settings.js)) {
            if (toursActive.get(tour)?.[key] !== value) {
              tourFound = false
              break
            }
          }

        } else { 
          break
        }
      }
    }

    if (!tourFound) {
      return
    }

    // filter steps
    const steps = scenario.steps.filter(
      (step) => (step.roles === null || step.roles.includes(currentRole.value))
        && (
          elements.has(step.tooltip_element_id) // elements exists
          // || (step.toggle__tooltip_element_id && elements.has(step.toggle__tooltip_element_id)) // element under toggler
        )
    )

    if (!steps.length) {
      return
    }

    scenariosToReturn.push({
      ...scenario,
      steps
    })
  })

  return scenariosToReturn
})

// current autoplay scenarios
// - current scenarios which was not viewed by user
const autoplayScenarios = computed(() => {
  return availableScenarios.value.filter((scenario) => !scenario.viewed && !viewedAutoplayScenariosIds.has(scenario.id))
})

const mapStepsToDriver = (scenarios) => {
  const steps = []

  scenarios.forEach((scenario) => {
    scenario.steps.forEach((step) => {
      const driverStep = {
        element: `[data-driver-element="${step.tooltip_element_id}"]`,
        popover: {
          title: step.header,
          description: step.content,
        },
        toggle__tooltip_element_id: step.toggle__tooltip_element_id
      }
      
      steps.push(driverStep)
    })
  })

  return steps
}

// driver available steps
// - driver steps summarized over current active scenarios
const driverAvailableSteps = computed(() => {
  return mapStepsToDriver(availableScenarios.value)
})

// driver available auto play steps
// - driver steps summarized over current autoplay scenarios
const driverAutoplaySteps = computed(() => {
  return mapStepsToDriver(autoplayScenarios.value)
})

export {
  elements,
  toursActive,
  showDriver,
  currentRole,
  scenarios,
  availableScenarios,
  autoplayScenarios,
  driverAvailableSteps,
  driverAutoplaySteps,
  viewedAutoplayScenariosIds
}
